<template>
    <div>
        <BusyLoader></BusyLoader>
        <div class="srx-lander-container">
            <div class="srx-lander-container">
                <div>
                    <section class="hero-section hero-ten">
                        <div class="container">
                            <div class="row align-items-center">
                                <div class="col-lg-12 col-md-10">
                                    <div class="hero-content-wrap mt-lg-0 mt-xl-0">
                                        <h1 class="fw-bold display-5 text-center zoom-in-zoom-out" style="font-weight: bold; font-size: 50px;">Welcome to SmartRX+</h1>
                                        <h3 class="text-center">
                                            The Smart Health Savings Solution
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <section class="discount-card pt-60 pb-120">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 col-md-12">
                                <div class="cyber-about-img text-center mb-30 mb-lg-0">
                                    <img src="/sl/images/about_cyber.jpg" class="img-fluid">
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="pt-4">
                                    <div class="section-heading mb-2">
                                        <h5 class="h6 text-primary">Get Discount Card</h5>
                                        <h2>Get started with your free Discount Card and save on all your future prescriptions.</h2>
                                        <p>Simply show your card the next time you pick up an Rx and save! SmartRx users have seen savings up to 80% on their prescriptions - prices lower than their co-pay!</p>
                                    </div>
                                    <div class="row" style="padding: 0px 10px;">
                                        <div class="" style="display: flex; grid-gap: 30px;">
                                            <a href="#" @click="discountCard($event)" class="getmycard-btn mt-3 btn btn-primary me-auto">Get My Card</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="cyber-features bg-light">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-md-8 col-lg-6">
                                <div class="section-heading text-center mb-5 mt-2">
                                    <h2 class="font-weight-bold">
                                        Lower the cost of your prescriptions and get all <br>
                                        of the following perks*
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-lg-4" v-for="benefit in Object.values(benefits)" :key="benefit.type">
                                <div class="cyber-single-service bg-white rounded-custom mb-30">
                                    <div class="feature-icon pb-3 rounded bg-primary-soft text-primary">
                                        <img :src="LanderHelper.getBenefitImage(benefit.benefitType)" style="width: 100px;">
                                    </div>
                                    <div class="cyber feature-info-wrap" style="text-align: center;">
                                        <p style="margin: 0;">
                                            {{benefit.description}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script setup>

import {computed, inject, onMounted, watch, nextTick} from 'vue';
import {useStore} from "vuex";
import useThanq from "../lander/composables/thanq";

import LanderHelper from '../helpers/LanderHelper';
import Footer from '../components/Footer'
import BusyLoader from '../components/BusyLoader'

const {upsells, data} = useThanq('smartrxplus');
const store = useStore();
const getters = store.getters;

const currency = computed(() => getters.currency);
const benefits = computed(() => getters.benefits);

onMounted(() => {
    document.title = 'Thank You For Joining SmartRx+';
    postToParent({ action: 'session' })
})

const discountCard = (e) => {
    e.preventDefault()
    //window.top.location = "/account/card"
    postToParent({ action: 'card' })
}

const rebates = (e) => {
    e.preventDefault()
    //window.top.location = "/account/rebates"
    postToParent({ action: 'rebates' })
}

const postToParent = (data) => {
    var event = new CustomEvent('orgsub', { 'detail': data })
    window.parent.document.dispatchEvent(event)
}

watch(() => benefits, () => {
    // Wait until the benefits are rendered in the iframe and then resize the frame
    nextTick(() => {
        setTimeout(() => {
            postToParent({ action: 'resize' })
        }, 3000)
    })
}, {deep: true})

</script>

<style>
.page-header .page-header-logo {
    max-width: 257px;
    padding: 20px 0;
    display: flex;
    justify-content: center;
}
@media (max-width: 991px) {
    .page-header .page-header-logo img {
        height: auto;
        max-width: 100%;
        margin: 0 auto;
    }
}

.logo {
    max-height: 100px;
    width: 80% !important;
}
.section-heading h2 {
    font-size: 23px;
}
.discount-card {
    padding: 40px 30px 50px 30px;
}
.discount-card .img-fluid {
    max-width: 70%;
    height: auto;
}
.discount-card h2 {
    font-size: 32px;
    font-weight: bold;
    font-family: "Poppins", sans-serif;
}
.discount-card p {
    font-size: 18px;
    margin: 20px 0px;
}
.discount-card contaner {
    width: 1000px;
}
.getmycard-btn {
    background: #d35902;
    padding: 8px 50px;
    border: #d35902;
    font-size: 20px;
    font-weight: bold;
}
.getmycard-btn:hover {
    background: #ba4e01;
}
.cyber-features {
    padding: 20px 10px;
}
.cyber-single-service {
    padding: 15px;
}
.mb-30 {
    margin-bottom: 30px;
}
.rounded-custom {
    border-radius: 1rem !important;
}
.feature-icon {
    text-align: center;
}

.bg-primary-soft {
    /* background-color: rgba(23, 92, 255, 0.2); */
}

.feature-info-wrap p {
    margin: 0;
    font-size: 15px;
}

.footer {
    padding: 5px 0;
}

.footer ul.navbar-nav li {
    border-right: 1px solid #dedcfc;
    margin-bottom: -1px;
    padding: 0 7px 0 0px;
}

.footer p#footerCopy {
    color: #000;
    margin: 0 auto;
    max-width: 840px;
    padding: 0 0 10px;
    text-align: center;
}
.footer .navbar {
    padding: 0.1rem 1rem;
}

.hand-text {
    font-weight: normal;
    font-size: 16px;
    color: #000;
    margin-top: -10px;
    margin-bottom: 9px;
    text-align: left;
}

.coupon-panel .dash-border {
    padding: 0px 0px;
    border: 1px solid #162d8d;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-top: 0;
}

.coupon-panel .coupon-label {
    padding: 0px;
    background: #162d8d;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.coupon-panel .coupon-label .logo-discount-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 5px;
}
.coupon-panel .coupon-label .logo-discount-head .logo-section {
    display: flex !important;
    flex: 1;
}
.coupon-panel .headline {
    font-size: 15px;
    font-weight: bold;
    color: #fff;
    padding: 0 24px 0 0 !important;
    margin: 0;
}

.coupon-panel .coupon-details .coupon-info {
    display: flex;
    width: 100%;
}
.coupon-panel .coupon-details .coupon-info .drug-tablet-info {
    width: 60%;
    padding: 0px 19px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-right: 3px solid #00b173;
}

.drug-tablet-info h2 {
    font-size: 26px;
    font-weight: 600;
}
.drug-tablet-info h5 {
    font-weight: 400;
    font-size: 16px;
    line-height: 10px;
    color: rgb(89 103 98);
}
.price-panel {
    display: flex;
    padding: 10px 0px 14px;
    border: 3px dashed #00b173;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
}
.price-panel .currency-text {
    font-family: Matter, sans-serif;
    font-weight: 600;
    font-size: 24px;
    margin-right: 4px;
    padding-bottom: 8px;
    color: #00b173;
    line-height: 36px;
}

.price-panel .price-text {
    font-family: Matter, sans-serif;
    font-weight: 600;
    font-size: 40px;
    line-height: 44px;
    color: #00b173;
}

.coupon-panel .coupon-details .coupon-info .rx-id-info {
    width: 40%;
    padding: 0px 10px;
}

.coupon-panel .coupon-details .form-group {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-weight: bold;
    color: #0a1c65;
    margin: 0;
}
.coupon-panel .coupon-details .form-group p {
    margin: 0px;
    color: #000;
    font-size: 15px;
}

.coupon-panel .phar-id-info label {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 0;
    background: #00b173;
    width: 100%;
    padding: 0px 8px;
}

.coupon-panel .phar-id-info p {
    font-size: 16px;
    color: #363436;
    padding: 2px 0px;
    font-weight: bold;
}

.url-discount-info {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    padding: 4px 10px;
    color: #000;
    flex-direction: column;
    align-items: flex-start;
}

.coupon-btn-panel {
    text-align: center;
    display: flex;
    justify-content: space-around;
    grid-gap: 10px;
}

.coupon-btn-style {
    width: 100%;
    border: 2px solid #f86700;
    color: #fff !important;
    background: #f86700;
    font-size: 17px;
    padding: 3px 10px;
    max-width: 130px;
}

.coupon-btn-style:hover {
    border: 2px solid #df5d00;
    color: #df5d00 !important;
}

.header-panel .img-fluid {
    max-width: fit-content !important;
}

@media (min-width: 992px) {
    .modal-lg,
    .modal-xl {
        max-width: 600px !important;
    }
}
.modal-backdrop.show {
    opacity: 0.8 !important;
}
.modal-backdrop {
    z-index: 9999;
}
.modal-content {
    border: 0px solid rgba(12, 8, 0, 0.2);
}

.coupon-deatils {
    background-color: #dbe0f4;
    padding: 6px 20px;
    width: 210px;
    margin: 10px 20px;
    border-radius: 10px;
    height: 125px;
}
.drug-info {
    text-align: center;
    padding: 10px 20px;
}
.drug-info h1 {
    font-size: 30px;
}
.drug-info h5 {
    font-size: 13px;
    color: #7d7d7d;
    font-weight: normal;
}
.drug-info div p {
    font-size: 14px;
    color: #000000;
    font-weight: bold;
    margin: 0;
}
.drug-info div div {
    font-weight: bold;
    font-size: 50px;
    line-height: 44px;
    color: #000;
}

.coupon-panel-footer {
    background: #e7e8ef;
    border-top: 1px solid #ccc;
    padding: 10px 50px;
}
.resp-panel {
    padding: 10px;
    margin: 10px 0px;
}

.coupon-btn-style:active,
.coupon-btn-style:focus {
    border-color: #092ebf !important;
    background-color: #092ebf !important;
}
.overlay {
    height: 100% !important;
    position: fixed;
}
.hero-section {
    background: #fff;
    padding: 50px 0 50px;
}

.hero-content-wrap h1 {
    font-weight: bold;
    font-size: 50px;
}
@media (min-width: 367px) and (max-width: 575px) {
    .coupon-panel .coupon-details .coupon-info {
        display: flex;
        width: 100%;
        flex-direction: column;
        flex-wrap: nowrap;
    }
    .coupon-panel .coupon-label .logo-discount-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 5px;
        flex-direction: column;
    }
    .coupon-deatils {
        width: 87%;
    }
    .hero-section {
        padding: 10px 0 10px;
    }
    .discount-card {
        padding: 10px 30px 20px 30px;
    }
    .cyber-about-img {
        margin-bottom: 0px !important;
    }
    .discount-card h2 {
        font-size: 20px;
    }
    .cyber-features .section-heading {
        margin-bottom: 1rem !important;
    }
    .hero-content-wrap h1 {
        font-weight: bold;
        font-size: 34px;
    }
    .hero-content-wrap h3 {
        font-size: 22px;
    }
    .claim-cta {
        padding: 0px 0px;
    }
}

.logo-section img {
    width: 80%;
}
.coupon-deatils {
}
.send-coupon {
    width: 100%;
    height: 44px;
    padding: 9px;
}
.send-btn {
    color: #fff;
    background-color: #d35902;
    border-color: #d35902;
    padding: 8px 40px;
    font-size: 15px;
}
.send-btn:hover {
    background: #ba4e01;
    background-color: #ba4e01;
}
.terms-text {
    font-size: 12px;
    margin-top: 20px;
}
.modal {
    z-index: 999999;
}
.fade:not(.in) {
    opacity: 0;
}
.fade {
    transition: opacity 0.15s linear;
    opacity: 0.5;
}

.modal-backdrop {
    background-color: #000000cf;
}
#couponDialog .modal-dialog {
    max-width: 600px !important;
}

.modal:nth-of-type(even) {
    z-index: 99999999 !important;
}
.modal-backdrop.in:nth-of-type(even) {
    z-index: 9999999 !important;
}
.claim-cta {
    padding: 40px 0px;
}
.claim-cta-bg {
    /* border: 1px dashed #ccc; */
    padding: 14px 40px;
    /* background:#ffd3e0 */
}
.claim-cta-btn a {
    width: 100%;
}
.claim-cta-info p {
    font-size: 20px;
}

.claim-cta-info h2 {
    font-size: 40px;
    font-weight: bold;
}
.claim-cta-bg .send-btn {
    font-size: 21px;
}

.zoom-in-zoom-out {
  animation: zoom-in-zoom-out 2s ease-out 2;
}


@keyframes zoom-in-zoom-out {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
</style>
